<template>
  <div class="text-block" :style="{ textAlign: alignment }">
    <ReadMore :text="content" marker="[readmore]" :auto-truncate="false" />
  </div>
</template>

<script>
import ReadMore from '@/components/ReadMore.vue'

export default {
  name: 'TextBlock',
  components: { ReadMore },
  props: {
    data: {
      type: Object,
      required: true,
      validator: (value) => value.content !== undefined
    }
  },
  computed: {
    alignment() {
      return this.data.alignment || 'left'
    },
    content() {
      return this.data.content || ''
    }
  }
}
</script>

<style scoped>
.text-block {
  padding: 0;

  & :deep(.rm-para),
  & :deep(.rm-text) {
    white-space: pre-wrap;
    line-height: 1.6;
    color: var(--color-text);
    font-size: var(--font-base);
  }
}
</style>
